import { STEP_ROUTER_KEY_MAP, TABLEYAPE_DYNAMIC, TABLEYAPE_STATIC } from '@/pages/performance/pages/multipleAssessTable/configs/index'
import { NAV_PROJECT_ASSESS } from '@/pages/performance/constants'
/**
 * 绩效评估 中间跳转路由
 */
export const PerfTansferPage = {
  path: '',
  meta: {
    name: '页面跳转',
    nav: NAV_PROJECT_ASSESS
  },
  children: [
    {
      path: 'mr/:projectId/:stepWorkId',
      component: () => import('../layout/layoutContent/contents/jumpLoadingContent/index.vue')
    },
    {
      path: 'mr/:projectId/:stepWorkId/preview',
      component: () => import('../layout/layoutContent/contents/jumpLoadingContent/index.vue')
    }
  ]
}

/**
 * 绩效评估相关路由
 */
export const PerfAssessPages = {
  path: '',
  component: () => import('../layout/layoutContent/contents/assessContent/index.vue'),
  meta: { name: '绩效内容', nav: NAV_PROJECT_ASSESS },
  children: [
    // 环节内容填写
    {
      path: 'assess/:projectId/:stepWorkId/:assessOfUserId/write',
      component: () => import('../pages/writeAssess/index.vue'),
      meta: { name: '评估型环节-填写-给他人填写' }
    },
    {
      path: 'assess/:projectId/:stepWorkId/write',
      component: () => import('../pages/writeAssess/index.vue'),
      meta: { name: '评估型环节-填写-自己填写自己' }
    },
    // 我的绩效 - 评估型环节
    {
      path: 'assess/:projectId/:stepWorkId/preview',
      component: () => import('../pages/myAssessPreview/normal.vue'),
      meta: { name: '评估型环节-查看' }
    },
    {
      path: 'results/:projectId/:stepWorkId/preview',
      component: () => import('../pages/myAssessPreview/results.vue'),
      meta: { name: '评估型环节-查看' }
    },
    // 给他人的评估 - 360评估
    {
      path: 'annular',
      redirect: '/perf',
      meta: { name: '360°评估环节' },
      children: [
        {
          path: 'assess/:projectId/:stepWorkId/preview',
          component: () => import('../pages/multipleAssessTable/index.vue'),
          meta: {
            routeKey: STEP_ROUTER_KEY_MAP.ANNULAR_ASSESS,
            tableType: TABLEYAPE_DYNAMIC,
            name: '360°评估环节-待评估列表'
          }
        }
      ]
    },
    // 团队绩效 - 团队评估
    {
      path: 'team',
      redirect: '/perf',
      meta: { name: '团队绩效' },
      children: [
        {
          path: 'assess/:projectId/:stepWorkId',
          component: () => import('../pages/multipleAssessTable/index.vue'),
          meta: {
            routeKey: STEP_ROUTER_KEY_MAP.TEAM_ASSESS,
            tableType: TABLEYAPE_DYNAMIC,
            name: '团队绩效-评估'
          }
        },
        {
          path: 'view/:projectId/:stepWorkId',
          component: () => import('../pages/multipleAssessTable/index.vue'),
          meta: {
            routeKey: STEP_ROUTER_KEY_MAP.TEAM_VIEW,
            tableType: TABLEYAPE_DYNAMIC,
            name: '团队绩效-查看团队绩效结果'
          }
        },
        {
          path: 'check/:projectId/:stepWorkId',
          component: () => import('../pages/teamCheck/index.vue'),
          meta: { name: '团队绩效-绩效校准' }
        },
        {
          path: 'confrimInvite/:projectId/:stepWorkId',
          component: () => import('../pages/annularConfrim/index.vue'),
          meta: {
            routeKey: STEP_ROUTER_KEY_MAP.CONFRIM_INVITE,
            tableType: TABLEYAPE_STATIC,
            name: '团队绩效-360°确认环节'
          }
        }
      ]
    },
    {
      path: 'results',
      redirect: '/perf',
      meta: { name: '结果复议环节' },
      children: [
        {
          path: 'review/:projectId/:stepWorkId',
          component: () => import('../pages/resultReview/index.vue'),
          meta: {
            routeKey: STEP_ROUTER_KEY_MAP.RESULT_REVIEW,
            tableType: TABLEYAPE_STATIC,
            name: '结果复议环节'
          }
        }
      ]
    }
  ]
}

export default PerfAssessPages
